import { Model } from 'app/model/backendmodel';
import { FormatReadSettings } from 'app/model/pipeline/copysource/format-read-settings/format-read-settings';
import { AdapterRegistry, Metamodel } from 'shell-models-lib';
import { ZipDeflateCompressionReadSettings } from 'app/model/pipeline/copysource/compression-read-settings/zip-deflate-compression-read-settings';
import { compressionReadSettingsAdapts, CompressionReadSettingsAdapter } from './compression-read-settings.adapter';
import { ValueAdapter } from 'app/model/adapters/value.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(ZipDeflateCompressionReadSettings),
    asynchronous: true,
    adapts: {
        ...compressionReadSettingsAdapts,
        preserveZipFileNameAsFolder: '*'
    }
})
export class ZipDeflateCompressionReadSettingsAdapter extends CompressionReadSettingsAdapter<
    ZipDeflateCompressionReadSettings,
    Model.CompressionReadSettings
> {
    protected override async _toResource(
        model: ZipDeflateCompressionReadSettings
    ): Promise<Model.CompressionReadSettings> {
        const result: Model.CompressionReadSettings =
            CompressionReadSettingsAdapter.getCommonCompressionReadSettingsProperties(
                Metamodel.modelFor(ZipDeflateCompressionReadSettings).name
            );
        result.preserveZipFileNameAsFolder = ValueAdapter.toResource(
            model,
            ZipDeflateCompressionReadSettings.PRESERVE_ZIPFILE_NAME_AS_FOLDER
        );
        return result;
    }

    protected override async _toModel(
        resource: Model.CompressionReadSettings,
        formatReadSettings: FormatReadSettings
    ): Promise<ZipDeflateCompressionReadSettings> {
        const result = CompressionReadSettingsAdapter.createCompressionReadSettingsWithCommonProperties(
            ZipDeflateCompressionReadSettings.MODEL,
            formatReadSettings
        ) as ZipDeflateCompressionReadSettings;
        ValueAdapter.toModel(
            result,
            ZipDeflateCompressionReadSettings.PRESERVE_ZIPFILE_NAME_AS_FOLDER,
            resource.preserveZipFileNameAsFolder
        );
        return result;
    }
}
